<po-page-default>
  <po-page-change-password
    [p-logo]="(logoUrl$ | async) ?? 'assets/brand/logo-ascensus-positiva.png'"
    [p-requirements]="requirements"
    [p-url-back]="urlBack"
    [p-url-home]="urlHome"
    (p-submit)="onSubmit($event)">
  </po-page-change-password>
</po-page-default>
